// extracted by mini-css-extract-plugin
module.exports = {"description":"RoleList_description__gttTx","button":"RoleList_button__3Lpi9"};